import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navdata = () => {
    const { t } = useTranslation();
    const history = useNavigate();
    const [isDashboard, setIsDashboard] = useState(false);
    const [isShop, setIsShop] = useState(false);
    const [isOrders, setIsOrders] = useState(false);
    const [isInvoices, setIsInvoices] = useState(false);
    const [isDownloadCentre, setIsDownloadCentre] = useState(false);
    const [isContact, setIsContact] = useState(false);
    const [isHandbook, setIsHandbook] = useState(false);
    const [isAllUsers, setIsAllUsers] = useState(false);
    const [isAllOrders, setIsAllOrders] = useState(false);
    const [isOrderForm4, setIsOrderForm4] = useState(false);
    const [isPostgresTools, setIsPostgresTools] = useState(false);
    const [isDownloadAdmin, setIsDownloadAdmin] = useState(false);
    const [isCart, setIsCart] = useState(false);
    const [isSavedCarts, setIsSavedCarts] = useState(false);
    const [isFavorites, setIsFavorites] = useState(false);
    const [isCustomerCart, setIsCustomerCart] = useState(false);
    const [isUserOrders, setIsUserOrders] = useState(false);
    const [isSubAccounts, setIsSubAccounts] = useState(false);
    const [isSalesOffersClient, setIsSalesOffersClient] = useState(false);
    const [isSalesOffersSales, setIsSalesOffersSales] = useState(false);
    const [isSalesOffersAdmin, setIsSalesOffersAdmin] = useState(false);
    const [isAllRMAtickets, setIsAllRMAtickets] = useState(false);
    const [isNews, setIsNews] = useState(false);
    const [isProductionTerms, setIsProductionTerms] = useState(false);

    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    const [isEmail, setEmail] = useState(false);
    const [isSubEmail, setSubEmail] = useState(false);
    const [isEcommerce, setIsEcommerce] = useState(false);
    const [isProjects, setIsProjects] = useState(false);
    const [isTasks, setIsTasks] = useState(false);
    const [isCRM, setIsCRM] = useState(false);
    const [isCrypto, setIsCrypto] = useState(false);

    const [isSupportTickets, setIsSupportTickets] = useState(false);
    const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
    const [isJobs, setIsJobs] = useState(false);
    const [isJobList, setIsJobList] = useState(false);
    const [isCandidateList, setIsCandidateList] = useState(false);

    const [isSignIn, setIsSignIn] = useState(false);
    const [isSignUp, setIsSignUp] = useState(false);
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [isPasswordCreate, setIsPasswordCreate] = useState(false);
    const [isLockScreen, setIsLockScreen] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const [isSuccessMessage, setIsSuccessMessage] = useState(false);
    const [isVerification, setIsVerification] = useState(false);
    const [isError, setIsError] = useState(false);

    const [isProfile, setIsProfile] = useState(false);
    const [isLanding, setIsLanding] = useState(false);
    const [isApex, setIsApex] = useState(false);
    const [isLevel1, setIsLevel1] = useState(false);
    const [isLevel2, setIsLevel2] = useState(false);

    const [iscurrentState, setIscurrentState] = useState("Dashboard");

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id)) {
                    document.getElementById(id).classList.remove("show");
                }
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        if (iscurrentState !== "Dashboard") setIsDashboard(false);
        if (iscurrentState !== "Shop") setIsShop(false);
        if (iscurrentState !== "Orders") setIsOrders(false);
        if (iscurrentState !== "Invoices") setIsInvoices(false);
        if (iscurrentState !== "Download Centre") setIsDownloadCentre(false);
        if (iscurrentState !== "All Users") setIsAllUsers(false);
        if (iscurrentState !== "All Tickets") setIsAllRMAtickets(false);
        if (iscurrentState !== "All Orders") setIsAllOrders(false);
        if (iscurrentState !== "Order Form 4") setIsOrderForm4(false);
        if (iscurrentState !== "PostgreSQL Tools") setIsPostgresTools(false);
        if (iscurrentState !== "Download Admin") setIsDownloadAdmin(false);
        if (iscurrentState !== "Cart") setIsCart(false);
        if (iscurrentState !== "Saved Carts") setIsSavedCarts(false);
        if (iscurrentState !== "Favorites") setIsFavorites(false);
        if (iscurrentState !== "User Orders") setIsUserOrders(false);
        if (iscurrentState !== "Sub Accounts") setIsSubAccounts(false);
        if (iscurrentState !== "Sales Offers Client") setIsSalesOffersClient(false);
        if (iscurrentState !== "Sales Offers Sales") setIsSalesOffersSales(false);
        if (iscurrentState !== "Sales Offers Admin") setIsSalesOffersAdmin(false);
        if (iscurrentState !== "News") setIsNews(false);
        if (iscurrentState !== "Contact") setIsContact(false);
        if (iscurrentState !== "Pages") setIsPages(false);
        if (iscurrentState !== "BaseUi") setIsBaseUi(false);
        if (iscurrentState !== "AdvanceUi") setIsAdvanceUi(false);
        if (iscurrentState !== "Forms") setIsForms(false);
        if (iscurrentState !== "Tables") setIsTables(false);
        if (iscurrentState !== "Charts") setIsCharts(false);
        if (iscurrentState !== "Icons") setIsIcons(false);
        if (iscurrentState !== "Maps") setIsMaps(false);
        if (iscurrentState !== "MuliLevel") setIsMultiLevel(false);
        if (iscurrentState !== "Landing") setIsLanding(false);
    }, [
        history,
        iscurrentState,
        isDashboard,
        isShop,
        isOrders,
        isInvoices,
        isDownloadCentre,
        isContact,
        isHandbook,
        isAllRMAtickets,
        isCart,
        isSavedCarts,
        isFavorites,
        isCustomerCart,
        isUserOrders,
        isSubAccounts,
        isSalesOffersClient,
        isSalesOffersSales,
        isSalesOffersAdmin,
        isNews,
        isOrderForm4,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel,
    ]);

    const menuItems = [
        {
            label: t('nav.start'),
            isHeader: true,
            auth: "client"
        },
        {
            id: "dashboard",
            label: t('nav.dashboard'),
            icon: "mdi mdi-view-dashboard-outline",
            link: "/",
            auth: "client",
            stateVariables: isDashboard,
            click: function (e) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState("Dashboard");
                updateIconSidebar(e);
            },
        },
        {
            label: t('nav.sales'),
            isHeader: true,
            auth: "client"
        },
        {
            id: "order-form-4",
            label: t('nav.orderForm'),
            icon: "mdi mdi-clipboard-text-outline",
            link: "/order-form",
            auth: "client",
            permission: "shop",
            customerCartOnly: true,
            stateVariables: isOrderForm4,
            click: function (e) {
                e.preventDefault();
                setIsOrderForm4(!isOrderForm4);
                setIscurrentState("Order Form");
                updateIconSidebar(e);
            },
        },
        {
            id: "cart",
            label: t('nav.cart'),
            icon: "mdi mdi-cart-outline",
            link: "/cart",
            auth: "client",
            permission: "shop",
            customerCartOnly: true,
            stateVariables: isCart,
            click: function (e) {
                e.preventDefault();
                setIsCart(!isCart);
                setIscurrentState("Cart");
                updateIconSidebar(e);
            },
        },
        {
            id: "saved-carts",
            label: t('nav.savedCarts'),
            icon: "mdi mdi-content-save-outline",
            link: "/saved-carts",
            auth: "client",
            permission: "shop",
            stateVariables: isSavedCarts,
            click: function (e) {
                e.preventDefault();
                setIsSavedCarts(!isSavedCarts);
                setIscurrentState("Saved Carts");
                updateIconSidebar(e);
            },
        },
        {
            id: "favorites",
            label: t('nav.favorites'),
            icon: "mdi mdi-heart-outline",
            link: "/favorites",
            auth: "client",
            permission: "shop",
            stateVariables: isFavorites,
            click: function (e) {
                e.preventDefault();
                setIsFavorites(!isFavorites);
                setIscurrentState("Favorites");
                updateIconSidebar(e);
            },
        },
        {
            id: "orders",
            label: t('nav.orders'),
            icon: "mdi mdi-clipboard-list-outline",
            link: "/orders",
            auth: "client",
            subaccountPermissions: ["shop", "orders"],
            stateVariables: isUserOrders,
            click: function (e) {
                e.preventDefault();
                setIsUserOrders(!isUserOrders);
                setIscurrentState("User Orders");
                updateIconSidebar(e);
            },
        },
        {
            id: "invoices",
            label: t('nav.invoices'),
            icon: "mdi mdi-file-document-outline",
            link: "/invoices",
            auth: "client",
            permission: "invoices",
            stateVariables: isInvoices,
            click: function (e) {
                e.preventDefault();
                setIsInvoices(!isInvoices);
                setIscurrentState("Invoices");
                updateIconSidebar(e);
            },
        },
        {
            label: t('nav.offers'),
            isHeader: true,
            auth: "client"
        },
        {
            id: "sales-offers-client",
            label: t('nav.myOffers'),
            icon: "mdi mdi-briefcase-outline",
            link: "/sales-offers/client",
            auth: "client",
            roles: ["client", "subaccount"],
            permission: "sales-offers",
            stateVariables: isSalesOffersClient,
            click: function (e) {
                e.preventDefault();
                setIsSalesOffersClient(!isSalesOffersClient);
                setIscurrentState("Sales Offers Client");
                updateIconSidebar(e);
            },
        },
        {
            id: "sales-offers-sales",
            label: t('nav.salesOffers'),
            icon: "mdi mdi-account-tie-outline",
            link: "/sales-offers/sales",
            auth: "client",
            permission: "sales-offers-module",
            stateVariables: isSalesOffersSales,
            click: function (e) {
                e.preventDefault();
                setIsSalesOffersSales(!isSalesOffersSales);
                setIscurrentState("Sales Offers Sales");
                updateIconSidebar(e);
            },
        },
        {
            id: "customer-cart",
            label: t('nav.customerCart'),
            icon: "mdi mdi-account-arrow-right-outline",
            link: "/customer-cart",
            auth: "client",
            permission: "customer-cart",
            stateVariables: isCustomerCart,
            click: function (e) {
                e.preventDefault();
                setIsCustomerCart(!isCustomerCart);
                setIscurrentState("CustomerCart");
                updateIconSidebar(e);
            },
        },
        {
            label: t('nav.info'),
            isHeader: true,
            auth: "client"
        },
        {
            id: "production-terms",
            label: t('nav.productionTerms'),
            icon: "mdi mdi-calendar-clock-outline",
            link: "/production-terms",
            auth: "client",
            stateVariables: isProductionTerms,
            click: function (e) {
                e.preventDefault();
                setIsProductionTerms(!isProductionTerms);
                setIscurrentState("Production Terms");
                updateIconSidebar(e);
            },
        },
        {
            id: "news",
            label: t('nav.news'),
            icon: "mdi mdi-newspaper-variant-outline",
            link: "/news",
            auth: "client",
            stateVariables: isNews,
            click: function (e) {
                e.preventDefault();
                setIsNews(!isNews);
                setIscurrentState("News");
                updateIconSidebar(e);
            },
        },
        {
            id: "download-centre",
            label: t('nav.downloadCentre'),
            icon: "mdi mdi-cloud-download-outline",
            link: "/download-centre",
            auth: "client",
            stateVariables: isDownloadCentre,
            click: function (e) {
                e.preventDefault();
                setIsDownloadCentre(!isDownloadCentre);
                setIscurrentState("Download Centre");
                updateIconSidebar(e);
            },
        },
        {
            id: "contact",
            label: t('nav.contact'),
            icon: "mdi mdi-card-account-phone-outline",
            link: "/contact",
            auth: "client",
            stateVariables: isContact,
            click: function (e) {
                e.preventDefault();
                setIsContact(!isContact);
                setIscurrentState("Contact");
                updateIconSidebar(e);
            },
        },
        // {
        //     id: "handbook",
        //     label: t('nav.handbook'),
        //     icon: "mdi mdi-book-open-page-variant-outline",
        //     link: "/handbook",
        //     auth: "client",
        //     stateVariables: isHandbook,
        //     click: function (e) {
        //         e.preventDefault();
        //         setIsHandbook(!isHandbook);
        //         setIscurrentState("Handbook");
        //         updateIconSidebar(e);
        //     },
        // },
        {
            label: t('nav.admin'),
            isHeader: true,
            auth: "admin"
        },
        {
            id: "all-users",
            label: t('nav.users'),
            icon: "mdi mdi-account-group-outline",
            link: "/all-users",
            auth: "admin",
            permission: "users",
            stateVariables: isAllUsers,
            click: function (e) {
                e.preventDefault();
                setIsAllUsers(!isAllUsers);
                setIscurrentState("All Users");
                updateIconSidebar(e);
            },
        },
        {
            id: "all-orders",
            label: t('nav.allOrders'),
            icon: "mdi mdi-clipboard-text-multiple-outline",
            link: "/all-orders",
            auth: "admin",
            permission: "all-orders",
            stateVariables: isAllOrders,
            click: function (e) {
                e.preventDefault();
                setIsAllOrders(!isAllOrders);
                setIscurrentState("All Orders");
                updateIconSidebar(e);
            },
        },
        {
            id: "sales-offers-admin",
            label: t('nav.allOffers'),
            icon: "mdi mdi-briefcase-search-outline",
            link: "/sales-offers/admin",
            auth: "admin",
            permission: "all-sales-offers",
            stateVariables: isSalesOffersAdmin,
            click: function (e) {
                e.preventDefault();
                setIsSalesOffersAdmin(!isSalesOffersAdmin);
                setIscurrentState("Sales Offers Admin");
                updateIconSidebar(e);
            },
        },
        {
            id: "download-centre-admin",
            label: t('nav.downloadAdmin'),
            icon: "mdi mdi-folder-cog-outline",
            link: "/admin/download-centre",
            auth: "admin",
            permission: "download-centre",
            stateVariables: isDownloadAdmin,
            click: function (e) {
                e.preventDefault();
                setIsDownloadAdmin(!isDownloadAdmin);
                setIscurrentState("Download Admin");
                updateIconSidebar(e);
            },
        },
        {
            id: "postgres-tools",
            label: t('nav.psqlTools'),
            icon: "mdi mdi-database-cog-outline",
            link: "/postgres-tools",
            auth: "admin",
            stateVariables: isPostgresTools,
            click: function (e) {
                e.preventDefault();
                setIsPostgresTools(!isPostgresTools);
                setIscurrentState("PostgreSQL Tools");
                updateIconSidebar(e);
            },
        },
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
